<div class="container" id="wrap">
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 text-center">
            <img class="logo-landing" src="assets/images/logos/ic.svg" style="width: 70%;" alt="" />
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <div class="bg-registro-light" style="padding-top: 10px;padding-bottom: 10px; overflow: hidden;">
                <form [formGroup]="loginForm" (ngSubmit)="onNormalLogin()" class="row form-horizontal" novalidate>
                    <div class="col-lg-12 text-center mobile-content-hide">
                        <p class="titulo_bold">Iniciar sesión</p>
                    </div>
                    <div class="col-lg-12 text-left mobile-content-show">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <p class="titulo_bold">Iniciar sesión</p>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="col-lg-12 text-center mobile-content-hide">
                        <p class="subtitulo_normal">Ingresa a ICONSTRUYE</p>
                    </div>

                    <div class="col-lg-12 text-left mobile-content-show">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <p class="subtitulo_normal">Ingresa a ICONSTRUYE</p>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <a (click)="socialSignIn()" type="button" class=" btn btn-lg btn-block btn-google">
                                <img src="assets/images/icons/icon-google.svg" style="height: 17px; vertical-align: middle;" alt="" /> &nbsp; &nbsp; Inicia sesión con Google
                            </a>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <!-- <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <button (click)="signInEmpresa()" type="button" class="btn btn-primary btn-lg btn-block mt-2">Iniciar sesion con cuenta empresa</button>
                        </div>
                        <div class="col-lg-2"></div>
                    </div> -->

                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <div class="position-o-separacion mobile-content-hide" style="position: absolute; top:2px; left:48%; background-color: #ffffff; padding: 3px;">
                                o</div>
                            <div class="position-o-separacion mobile-content-show" style="position: absolute; top:-14px; left:48%; background-color: #ffffff; padding: 3px;">
                                o</div>
                            <hr>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label class="control-label">Correo electrónico</label>
                            <input name="txtUsername" type="email" [readonly]="formDisabled" class="form-control input-md placeholder-input" formControlName="txtUsername" placeholder="Ingresa tu correo electrónico" autocomplete="off" required />
                            <div *ngIf="loginForm.get('txtUsername').invalid && (loginForm.get('txtUsername').dirty)">
                                <div [hidden]="!loginForm.get('txtUsername').errors['required']" class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> Debes ingresar el correo electrónico.
                                </div>
                                <div [hidden]="!loginForm.get('txtUsername').errors['email']" class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> El dato ingresado debe ser un correo electrónico.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label class="control-label">Contraseña</label>
                            <input name="txtPassword" #x type="password" [readonly]="formDisabled" class="form-control input-md placeholder-input" placeholder="Ingresa tu contraseña" autocomplete="off" formControlName="txtPassword" required />
                            <span (click)="x.type = x.type == 'password' ? 'text' : 'password'" class="{{x.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}">
                            </span>
                            <div *ngIf="loginForm.get('txtPassword').invalid && (loginForm.get('txtPassword').dirty)">
                                <div [hidden]="!loginForm.get('txtPassword').errors['email']" class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> Debes ingresar tu contraseña.
                                </div>
                                <div [hidden]="!loginForm.get('txtPassword').errors['minlength']" class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> La contraseña debe tener un mínimo de 6 caracteres.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <div *ngIf="loginForm.valid && (!hiddenError)" class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                <div [hidden]="hiddenError"> <i class="fa fa-exclamation-triangle"></i> {{mensajeError}}</div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group form-group-login col-lg-8 text-center">
                            <a (click)="onClickPassword()" class="btn text-orange">
                                <strong> ¿Has olvidado tu contraseña?</strong></a>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12" *ngIf="mostrarCaptcha">
                        <div class="col-lg-2"></div>
                        <div class="form-group form-group-login col-lg-8 text-center">
                            <re-captcha #captchaRef="reCaptcha" name="captcha" formControlName="captcha"></re-captcha>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <input type="hidden"  [(ngModel)]="mostrarCaptcha" name="validarCaptcha" formControlName="validarCaptcha">
                            <button type="submit" [disabled]="!loginForm.valid || formDisabled" class="btn btn-lg btn-orange btn-block">Iniciar sesión</button>
                            <br>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </form>
            </div>
            <div class="col-lg-12">
                <br />
            </div>
        </div>
        <div class="col-lg-3"></div>
    </div>
</div>